/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import * as Msdyn365 from '@msdyn365-commerce/core';
import LinksComponent from './components/links';

import { IAbsoluteModalWindowData } from './absolute-modal-window.data';
import { IAbsoluteModalWindowProps } from './absolute-modal-window.props.autogenerated';

export interface IAbsoluteModalWindowViewProps extends IAbsoluteModalWindowProps<IAbsoluteModalWindowData> {

    modalTitle?: React.ReactNode;
    modalContent: string;
    modalImage: React.ReactNode;
    modalButtonText: string;
    modalButtonLink: string;
    links?: React.ReactNode;

}



/**
 *
 * AbsoluteModalWindow component
 * @extends {React.PureComponent<IAbsoluteModalWindowProps<IAbsoluteModalWindowData>>}
 */
class AbsoluteModalWindow extends React.PureComponent<IAbsoluteModalWindowProps<IAbsoluteModalWindowData>> {
    public render(): JSX.Element | null {

        //const { config } = this.props;

        const { 
            modalTitle,
            modalContent,
            modalImage,
            links
        } = this.props.config;

       

        const ModalTitle = modalTitle && (
            <Msdyn365.Text
              tag={modalTitle.tag || 'span'}
              text={modalTitle.text}
              editProps={{onEdit: this.handleTextChange, requestContext:this.props.context.request}}
            />
        );
        const ModalContent = modalContent && (
            <Msdyn365.RichTextComponent
                text={modalContent}
                editProps={{ onEdit: this.handleParagraphChange, requestContext: this.props.context.request }}
            />
        );
        const imageProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: modalImage && modalImage.imageSettings,
        };

        const ModalImage = modalImage && (
            <Msdyn365.Image {...modalImage} {...imageProps} editProps ={{key:this.props.config.modalImage || {}, requestContext: this.props.context.request}}/>
        );

        const contentBlockLinks = links && links.length > 0 && <LinksComponent {...{ links }} />;

        const AbsoluteModalProps = {
            ...this.props,
            modalTitle: ModalTitle,
            modalContent: ModalContent,
            modalImage: ModalImage,
            links: contentBlockLinks
        };

        

        return this.props.renderView(AbsoluteModalProps) as React.ReactElement;
    }
    public handleTextChange = (event: Msdyn365.ContentEditableEvent) => this.props.config.modalTitle!.text = event.target.value;
    public handleParagraphChange = (event: Msdyn365.ContentEditableEvent) => this.props.config.modalContent! = event.target.value;
}

export default AbsoluteModalWindow;
